import { css } from "styled-components"

const families = {
  primary: `"Fira Sans", "Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", "Tahoma", sans-serif`,
  secondary: `"Fira Sans", "Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", "Tahoma", sans-serif`,
}

const weights = {
  primary: {
    normal: 400,
    semibold: 600,
    bold: 700,
  },
  secondary: {
    normal: 400,
    semibold: 600,
    bold: 700,
  },
}

const set = (family, weight) => {
  try {
    return css`
      font-family: ${families[family]};
      font-weight: ${weights[family][weight]};
    `
  } catch (e) {
    // eslint-disable-next-line no-console
    return console.error(`Undefined font family/weight`, e.message, e.name)
  }
}

export default {
  set,
}
